import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getEventByPk } from '../functions/getEventById';
import SeoHelmet from '../components/SeoHelmet';
import { seo } from '../config/seo';
import '../styles/archive.css'

const truncateForMeta = (text, maxLen = 155) => {
  if (!text || typeof text !== 'string') return '';
  return text.length <= maxLen ? text : text.slice(0, maxLen - 3) + '...';
};

const ArchiveItem = () => {
  const { id } = useParams();
  const [eventData, setEventData] = useState([]);
  const [canDisplay, setCanDisplay] = useState(false);

  useEffect(() => {
    const OnStart = async() => {
      const data = await getEventByPk(Number(id));
      setEventData(data.data);
      setCanDisplay(true);
    }
    OnStart();
  }, [id]);

  const title = canDisplay && eventData?.header ? `${eventData.header} – Skiland Stará Myjava` : seo.pages.archive.title;
  const description = canDisplay && eventData?.text ? truncateForMeta(eventData.text) : seo.pages.archive.description;
  const image = canDisplay && eventData?.photos?.length ? process.env.REACT_APP_API_HOST + '/static/' + eventData.photos[0] : '';

  return (
    <div className="archive-item">
      <SeoHelmet title={title} description={description} image={image} />
      <h1>{eventData.header}</h1>
      <div className="archive-item-desc">
        <p>{eventData.text}</p>
      </div>
      <div className="photos-showcase">
          {canDisplay ? eventData.photos.map((photo, index) => <img src={process.env.REACT_APP_API_HOST + "/static/" + photo}/>) : ""}
      </div>
    </div>
  )
}

export default ArchiveItem